import { post } from '@/api/core'

import { GroupInviteCodeGetInfoRes } from './types'

export type { GroupInviteCodeGetInfoRes, GroupInviteCodeGetInfoResInfo } from './types'
/**
 * 群-入群码获取群信息
 * @description https://api.yinnho.cn/api.php?do=group_invite_code_get_info&help
 *
 * @param invite_code 入群码
 */
export function group_invite_code_get_info (invite_code: string) {
  return post<GroupInviteCodeGetInfoRes>('group_invite_code_get_info', { invite_code })
}
